import React from 'react';
import ReactDOM from 'react-dom'; // helps to hook our application from index.html
import App from './App';
import './index.css'

ReactDOM.render(<App/>, document.getElementById('root'))